import { render, staticRenderFns } from "./OrdenCompraFormV2.vue?vue&type=template&id=6d720afe&scoped=true"
import script from "./OrdenCompraFormV2.vue?vue&type=script&lang=js"
export * from "./OrdenCompraFormV2.vue?vue&type=script&lang=js"
import style0 from "./OrdenCompraFormV2.vue?vue&type=style&index=0&id=6d720afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d720afe",
  null
  
)

export default component.exports